// Traceability records shown in the "Trace Your Tea" section.
// Add one entry per real production lot; the key is the batch code
// with dashes/spaces removed, uppercased (WL-2401 -> WL2401).

export type TraceRecord = {
  batch: string;
  tea: string;
  estate: string;
  elevation: string;
  plucked: string;
  processed: string;
  blender: string;
  botanicals: string[];
  grade: string;
  taster: string;
};

export const traceLibrary: Record<string, TraceRecord> = {
  WL2401: {
    batch: "WL-2401",
    tea: "Ceylon Sovereign",
    estate: "Kandapola Garden, Nuwara Eliya",
    elevation: "1,910 m",
    plucked: "12 March 2026 · 05:48 IST",
    processed: "Orthodox · 16h withering · 32min oxidation",
    blender: "Anushka Perera",
    botanicals: ["Camellia sinensis (OP1)"],
    grade: "OP1 · Golden Tip",
    taster: "★★★★★ · Malt, cocoa, dried fig",
  },
  WL2402: {
    batch: "WL-2402",
    tea: "Rose Cardamom Noir",
    estate: "Uva Highlands · Blended on estate",
    elevation: "2,080 m",
    plucked: "04 April 2026 · 06:12 IST",
    processed: "Orthodox black · hand-blended in copper pans",
    blender: "Nishani Fernando",
    botanicals: ["Damask rose petals", "Green cardamom", "Calabrian bergamot oil"],
    grade: "FBOP · Small batch (48 tins)",
    taster: "★★★★★ · Rose, warm spice, citrus peel",
  },
  WL2403: {
    batch: "WL-2403",
    tea: "Silver Whisper",
    estate: "Adisham Estate, Uva",
    elevation: "2,110 m",
    plucked: "21 February 2026 · 05:30 IST",
    processed: "Sun-withered · unrolled · slow-dried",
    blender: "Rukshan de Silva",
    botanicals: ["Camellia sinensis silver buds only"],
    grade: "Silver Needle · First flush",
    taster: "★★★★★ · Honeysuckle, melon, silk",
  },
};

export const findBatch = (code: string) =>
  traceLibrary[code.replace(/[-\s]/g, "").toUpperCase()] ?? null;
